import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div className="contact-page">
      <div className="container">
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      </div>
    </div>
  );
};

export default NotFoundPage;